/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useSimpliCity } from "@simplicitycms/simplicity-common";
import { ErrorDisplay } from "cms/shared/error_display";
import { Header } from "layout-components/header";
import { Footer } from "layout-components/footer";
import { Home_Feeds } from "components/feeds";
import { ShareYourThoughts } from "components/share-your-thoughts";
import { ServicesList } from "components/services-list";
import { HomeHeroCarousel } from "components/hero-carousel";
import { Component } from "cms/fields/component";

const Layout_Homepage = () => {
    const { webpage, model, fields, error } = useSimpliCity();
    const content = fields?.content;

    return (
        <Fragment>
            <Header />
            <div tabIndex={-1} id="skip-content-start">
                {fields && (
                    <>
                        <div className="home-top-section">
                            <HomeHeroCarousel />
                        </div>
                    </>
                )}

                <div id="layout" className="layout homepage">

                    <ServicesList />

                    <Home_Feeds />

                    <div className="homepage-wrapper">
                        {model && (
                            <>
                                {fields &&
                                    <Component
                                        field={content}
                                        model={model}
                                        webpage={webpage}
                                    />
                                }

                                <ShareYourThoughts />
                            </>
                        )}
                    </div>
                </div>
            </div>

            <ErrorDisplay error={error} />

            <Footer />

        </Fragment>
    );
};
Layout_Homepage.displayName = "Layout_Homepage";
export { Layout_Homepage };
